export default "__VITE_ASSET__Bcw1M7gP__"